import { ReactElement, Suspense } from 'react';
import MainContent from '../../../components/MainContent';
import Header from './components/Header';
import Content from './components/Content';
import PageLayout from '../../../components/PageLayout';
import SideBar from '../../../components/SideBar';
import Loading from '../../../components/Loading';

const RecordingsListPage = (): ReactElement => (
  <PageLayout
    sidebar={<SideBar />}
    mainContent={
      <MainContent
        header={<Header title='録音一覧' />}
        content={
          <Suspense fallback={<Loading />}>
            <Content />
          </Suspense>
        }
      />
    }
  />
);

export default RecordingsListPage;
